export const getUsers = state => {
  const users = state.orm.users?.items

  if (!users) {
    return []
  }

  return Object.values(users)
}
